module.exports = __webpack_public_path__ + "img/Phone2.1ecf6ecd.svg";